import { useUnit } from 'effector-react';
import { $connectionStore } from '@lib/store/integrations';
import { useRouteHook } from '@shared/hooks';
import { RoutePaths } from '@shared/utils';
import { IntegrationStep, type IntegrationResponse } from '@shared/api/rest/integrations';
import { Button, ColorsEnum, Spinner, Text } from '@shared/widgets';

interface IIntegrationCardProps {
  integration: IntegrationResponse;
}

export const IntegrationCard = (props: IIntegrationCardProps) => {
  const connectionStore = useUnit($connectionStore.store);

  const { navigate } = useRouteHook();

  return (
    <div className='p-6 bg-white dark:bg-soft-black'>
      <div className='flex'>
        <div className='w-24 h-24 mr-5 bg-ice dark:bg-eerie-black flex-none flex items-center justify-center text-center'>
          <img className='flex-none object-contain' src='/images/tmp/xero-logo.svg' alt='Xero' />
        </div>
        <div>
          <Text className='mb-1' weight='medium' size='xl'>
            {props.integration.name}
          </Text>
          <Text size='sm' color={ColorsEnum.Secondary}>
            {props.integration.description}
          </Text>
        </div>
      </div>
      <div className='mt-5 -mr-5 flex items-center'>
        {props.integration.connected ? (
          <>
            <Button
              className='mr-5 flex-grow-1'
              color='outlined'
              fullWidth
              onClick={() => navigate(RoutePaths.integration.onNavigate(props.integration.name))}
            >
              Configure
            </Button>
            <Button
              className='mr-5 flex-grow-1'
              color='outlined'
              fullWidth
              onClick={() => $connectionStore.events.disconnect(props.integration.name)}
              disabled={connectionStore.loading || connectionStore.data === IntegrationStep.DISCONNECT}
            >
              Disconnect
              {(connectionStore.loading || connectionStore.data === IntegrationStep.DISCONNECT) && <Spinner embedded />}
            </Button>
          </>
        ) : (
          <Button
            className='mr-5 flex-grow-1'
            color='primary'
            fullWidth
            onClick={() => $connectionStore.events.connect(props.integration.name)}
            disabled={connectionStore.loading || connectionStore.data === IntegrationStep.CONNECT}
          >
            Integrate
            {(connectionStore.loading || connectionStore.data === IntegrationStep.CONNECT) && <Spinner embedded />}
          </Button>
        )}
      </div>
    </div>
  );
};
